/** Built-in supplier lead pipeline stages (not editable). */
export const FIXED_PIPELINE_STAGES = [
  { key: "new", label: "New Lead", color: "bg-blue-100 text-blue-800 border-blue-300", is_system: true },
  { key: "contacted", label: "Contacted", color: "bg-amber-100 text-amber-800 border-amber-300", is_system: true },
  { key: "quotation_sent", label: "Quotation Sent", color: "bg-violet-100 text-violet-800 border-violet-300", is_system: true },
  { key: "won", label: "Won", color: "bg-green-100 text-green-800 border-green-300", is_system: true },
  { key: "lost", label: "Lost", color: "bg-red-100 text-red-800 border-red-300", is_system: true },
];

export const DEFAULT_STAGE_COLOR = "bg-neutral-100 text-neutral-800 border-neutral-300";

export function mergePipelineStages(fixedFromApi, customFromApi) {
  const fixed =
    Array.isArray(fixedFromApi) && fixedFromApi.length > 0 ? fixedFromApi : FIXED_PIPELINE_STAGES;
  const custom = Array.isArray(customFromApi) ? customFromApi : [];
  return [...fixed, ...custom];
}

export function getStageMeta(stages, key) {
  const found = stages.find((s) => s.key === key);
  if (found) return found;
  return {
    key,
    label: key ? String(key).replace(/^custom_/, "").replace(/_/g, " ") : "—",
    color: DEFAULT_STAGE_COLOR,
  };
}

export function stageChoicesForAssignment(stages, status) {
  if (!status || stages.some((s) => s.key === status)) return stages;
  return [...stages, getStageMeta(stages, status)];
}
